import { Step00 } from "./Step00";
import { Step01 } from "./Step01";
import { Step02 } from "./Step02";
import { Step03 } from "./Step03";
import { Step04 } from "./Step04";
import { Step05 } from "./Step05";
import { Step06 } from "./Step06";
import { Step07 } from "./Step07";
import { Step08 } from "./Step08";
import { Step09 } from "./Step09";
import { Step10 } from "./Step10";
import { Step11 } from "./Step11";
import { Step12 } from "./Step12";
import { Step13 } from "./Step13";
import { Step14 } from "./Step14";
import { Step15 } from "./Step15";
import { Step16 } from "./Step16";
import { Step17 } from "./Step17";
import { Step18 } from "./Step18";
import { Step19 } from "./Step19";
import { Step20 } from "./Step20";

export const formSteps = {
  0: Step00,
  1: Step01,
  2: Step02,
  3: Step03, //partner details
  4: Step04, // Relationship
  5: Step05, // Marriage / De-Facto
  6: Step06, // Children
  7: Step07, // Children (add them)
  8: Step08, // Real Estate
  9: Step09, //  Income
  10: Step10, // Bank Accounts
  11: Step11, // Superannuation
  12: Step12, // Other Assets #1
  13: Step13, // Other Assets #2
  14: Step14, // Debts
  15: Step15, // Debts 2
  16: Step16, // Living Arrangements
  17: Step17, // Amicable
  18: Step18, // Past Steps
  19: Step19, // What Is Important To You
  20: Step20, // Submit details
};

export const formStepsTitle = [
  "",
  "",
  "",
  `1. Partner's Details`,
  `2. Relationship`,
  `3. Marriage / De-Facto`,
  `4. Children`,
  "5. Add Children",
  `6. Real Estate`,
  `7. Income`,
  `8. Bank Accounts`,
  `9. Superannuation`,
  `10. Other Assets #1`,
  `11. Other Assets #2`,
  `12. Debts #1`,
  `13. Debts #2`,
  `14. Living Arrangements`,
  `15. Amicable`,
  `16. Past Steps`,
  `17. What's important?`,
  `Submit Your Details`,
];
